import { useState } from 'react';

export default function About() {
  const [showDetailModal, setShowDetailModal] = useState(false);

  return (
    <>
      <section className="relative py-14 sm:py-24 px-4 sm:px-6 overflow-hidden" style={{background: 'linear-gradient(150deg, #0d1f3c 0%, #152a52 50%, #111e3a 100%)'}}>
        <div className="absolute inset-0 opacity-[0.035]" style={{backgroundImage: 'linear-gradient(128deg, transparent 43%, #c9a227 44%, #c9a227 44.4%, transparent 45%), linear-gradient(82deg, transparent 59%, #c9a227 60%, #c9a227 60.3%, transparent 61%)', backgroundSize: '360px 360px'}}></div>

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="mb-10 sm:mb-16 text-center">
            <h2 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white leading-[3.0] sm:leading-[3.2] mb-5 sm:mb-8 max-w-3xl mx-auto text-center">
              전원주택부터 선산까지,<br />
              두 공간을 완벽하게
            </h2>
            <p className="text-base sm:text-xl text-white/70 leading-relaxed max-w-4xl mx-auto">
              진주시 지역권역(사천,고성,하동,산청) 전원주택 소유자와 출향인을 위한<br className="hidden sm:block" />
              프리미엄 통합 관리 솔루션. 단순 노동이 아닌,<br className="hidden sm:block" />
              데이터 기반 전문 케어로 두 공간의 가치를 지킵니다.
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
            {/* Left Image */}
            <div className="w-full md:w-2/5">
              <div className="aspect-square rounded-2xl overflow-hidden shadow-xl border border-[#c9a227]/20">
                <img
                  src="https://public.readdy.ai/ai/img_res/739c9362b04ebe612cd5a8a62472f764.jpg"
                  alt="드론과 GPS 장비"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="flex-1 w-full">
              <div className="text-[#c9a227] text-7xl sm:text-[120px] font-serif leading-none mb-3 sm:mb-5">
                21
              </div>
              <p className="text-lg sm:text-2xl text-white/75 font-light leading-relaxed mb-7 sm:mb-10">
                객관적 요인 기반&nbsp;&nbsp;투명 견적 시스템
              </p>
              <button
                onClick={() => setShowDetailModal(true)}
                className="relative inline-flex items-center gap-2 px-7 sm:px-10 py-3 sm:py-4 rounded-full text-sm sm:text-base font-bold cursor-pointer whitespace-nowrap select-none text-[#0d1f3c] tracking-wide transition-all duration-100 hover:opacity-90 hover:translate-y-[2px] active:translate-y-[4px]"
                style={{
                  background: 'linear-gradient(135deg, #e8c84a, #b8860b)',
                  boxShadow: '0 6px 0 #7a5c06, 0 8px 14px rgba(0,0,0,0.4)',
                }}
              >
                <i className="ri-list-check-2 text-lg"></i>
                견적 요인 자세히 보기
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Detail Modal */}
      {showDetailModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4"
          style={{ backgroundColor: 'rgba(0,0,0,0.75)' }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowDetailModal(false); }}
        >
          <div className="rounded-2xl sm:rounded-3xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-y-auto relative border border-[#c9a227]/20" style={{background: 'linear-gradient(160deg, #1e3a6e, #0d1f3c)'}}>
            <button
              onClick={() => setShowDetailModal(false)}
              className="absolute top-4 right-4 sm:top-6 sm:right-6 z-10 w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition cursor-pointer shadow-lg"
            >
              <i className="ri-close-line text-xl sm:text-2xl text-white"></i>
            </button>

            <div className="p-7 sm:p-10 text-white rounded-t-2xl sm:rounded-t-3xl border-b border-[#c9a227]/20" style={{background: 'linear-gradient(135deg, rgba(201,162,39,0.15), rgba(184,134,11,0.08))'}}>
              <h2 className="text-2xl sm:text-4xl font-bold mb-2 sm:mb-3 text-white">홈앤그레이브 21가지 가격 산정 요인</h2>
              <p className="text-[#c9a227]/80 text-sm sm:text-lg">데이터 기반 투명한 견적 산출 시스템</p>
            </div>

            <div className="p-5 sm:p-10 space-y-10">
              {[
                {
                  num: '1', title: '현장 식생 및 지면 상태 (5항목)',
                  items: [
                    { icon: 'ri-ruler-line', title: '풀의 높이', desc: '예초기 부하와 작업 시간에 직접적인 영향을 미치는 요소입니다.' },
                    { icon: 'ri-plant-line', title: '잡목 및 덩굴 밀도', desc: '일반 풀 외에 덩굴 식물이나 억센 잡목의 혼재 정도를 측정합니다.' },
                    { icon: 'ri-leaf-line', title: '식생의 종류', desc: '가시나무, 칡넝쿨 등 특수 제거 장비가 필요한 식물의 존재 여부를 확인합니다.' },
                    { icon: 'ri-water-flash-line', title: '토양의 수분 상태', desc: '배수 상태에 따른 지면의 질척임 정도는 작업 효율에 영향을 줍니다.' },
                    { icon: 'ri-landscape-line', title: '지면 평탄도', desc: '두더지 굴이나 지면 함몰 등 예초기 칼날 손상 위험 및 보수 필요성을 확인합니다.' },
                  ]
                },
                {
                  num: '2', title: '지형 및 공간적 특성 (4항목)',
                  items: [
                    { icon: 'ri-map-pin-2-line', title: '작업 면적 (GPS 실측)', desc: '눈대중이 아닌 드론 및 위성 데이터를 통해 제곱미터(m²) 단위로 정밀 산출합니다.' },
                    { icon: 'ri-arrow-up-line', title: '경사도 (Angle)', desc: '가파른 지형은 작업자의 안전 확보 및 할증 면적 계산의 근거가 됩니다.' },
                    { icon: 'ri-mountain-line', title: '지형 복잡도', desc: '바위, 웅덩이 등 예초기가 접근하기 어려운 장애물의 분포도를 측정합니다.' },
                    { icon: 'ri-sun-line', title: '일조량 및 식생 회복률', desc: '위성 데이터 분석을 통해 향후 잡초 재발전 가능성을 예측합니다.' },
                  ]
                },
                {
                  num: '3', title: '구조물 및 석물 상태 (4항목)',
                  items: [
                    { icon: 'ri-group-line', title: '봉분의 수 및 크기', desc: '관리해야 할 구체적인 대상의 개수와 체적을 산정합니다.' },
                    { icon: 'ri-building-line', title: '비석 및 상석 상태', desc: '이끼 제거, 세척, 수평 보수 등 별도 케어가 필요한지 확인합니다.' },
                    { icon: 'ri-layout-masonry-line', title: '둘레석/석축 상태', desc: '무너짐이나 벌어짐 등 석재 구조물의 보수 필요성을 진단합니다.' },
                    { icon: 'ri-fence-line', title: '주변 펜스 및 경계물', desc: '울타리나 경계석 등 수작업 정밀 케어가 필요한 경계선의 길이를 측정합니다.' },
                  ]
                },
                {
                  num: '4', title: '물류 및 장비 진입 조건 (4항목)',
                  items: [
                    { icon: 'ri-walk-line', title: '주차장과의 거리', desc: '장비 운반 거리가 300m를 초과할 경우 운반 인건비가 가산됩니다.' },
                    { icon: 'ri-road-map-line', title: '진입로 경사 및 험로 여부', desc: '무거운 장비(엔진톱, 고압세척기 등)의 이동 난이도를 평가합니다.' },
                    { icon: 'ri-drop-line', title: '용수 확보 용이성', desc: '석물 세척 등을 위한 물 보충 가능 여부를 확인합니다.' },
                    { icon: 'ri-truck-line', title: '중장비 진입 가능성', desc: '굴착기 등 보수 공사를 위한 장비 진입로 확보 여부를 체크합니다.' },
                  ]
                },
                {
                  num: '5', title: '디지털 분석 및 리포트 수준 (4항목)',
                  items: [
                    { icon: 'ri-satellite-line', title: '위성 이력 분석 범위', desc: '과거 10년 치 위성 사진을 통한 지형 변화 추적 범위를 결정합니다.' },
                    { icon: 'ri-flight-takeoff-line', title: '드론 비행 난이도', desc: '고압선, 수목 밀집도 등 드론 촬영 및 데이터 수집의 난이도를 산정합니다.' },
                    { icon: 'ri-file-list-3-line', title: '보고서 상세 수준', desc: '단순 사진 전송부터 전문가 소견이 담긴 디지털 리포트까지 선택 옵션에 따릅니다.' },
                    { icon: 'ri-shield-check-line', title: '사후 케어 프로그램', desc: '재생 방지 처리 등 옵션 추가 여부에 따른 비용을 반영합니다.' },
                  ]
                },
              ].map((cat) => (
                <div key={cat.num}>
                  <h3 className="text-lg sm:text-2xl font-bold text-white mb-4 sm:mb-6 flex items-center gap-3">
                    <span className="text-[#0d1f3c] w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0" style={{background: 'linear-gradient(135deg, #e8c84a, #b8860b)'}}>{cat.num}</span>
                    {cat.title}
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    {cat.items.map((item, idx) => (
                      <div key={idx} className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 rounded-xl border border-[#c9a227]/15" style={{background: 'rgba(30,58,110,0.4)'}}>
                        <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center flex-shrink-0 rounded-lg border border-[#c9a227]/25" style={{background: 'rgba(201,162,39,0.12)'}}>
                          <i className={`${item.icon} text-xl sm:text-2xl text-[#c9a227]`}></i>
                        </div>
                        <div>
                          <h4 className="font-bold text-white mb-1 text-sm sm:text-base">{item.title}</h4>
                          <p className="text-xs sm:text-sm text-white/55 leading-relaxed">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}

              <div className="rounded-2xl p-5 sm:p-6 text-center border border-[#c9a227]/25" style={{background: 'rgba(201,162,39,0.08)'}}>
                <p className="text-white/80 leading-relaxed text-sm sm:text-base">
                  <strong className="text-[#c9a227]">21개 요인</strong>을 종합적으로 분석하여<br />
                  현장 실측 기반의 정확하고 투명한 견적을 제공합니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
